/**
 * EditIcon — sanitized from `assets/newSvg/edit.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function EditIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M20.1314,3.16091 C18.9598,1.98933 17.0603,1.98933 15.8888,3.16091 L15.1817,3.86801 L20.1314,8.81776 L20.8385,8.11065 C22.0101,6.93908 22.0101,5.03959 20.8385,3.86801 L20.1314,3.16091 Z M18.7172,10.232 L13.7674,5.28223 L4.67645,14.3732 C4.47766,14.572 4.33874,14.8227 4.27553,15.0966 L3.24747,19.5515 C3.08111,20.2724 3.72721,20.9183 4.44792,20.7519 L8.90283,19.7239 C9.17676,19.6607 9.42741,19.5218 9.6262,19.323 L18.7172,10.232 Z"
        fill={color}
      />
    </Svg>
  );
}

export default EditIcon;
